import { Badge, Tooltip } from '@nextui-org/react';
import { useTheme } from 'next-themes';
import { useState } from 'react';
import gradings from '../constants/gradings.json';
import Accordion from './Accordion';

export default function GradingSection({ gradings, showGrading }: any) {
  const [gradingAccordionOpen, setGradingAccordionOpen] = useState(false);
  const { resolvedTheme } = useTheme();

  return (
    <Accordion open={showGrading}>
      <div className="overflow-none divide-y border-t-2">
        <ul className="m-4">
          {gradings?.split(',').map((grading: string, i: number) => (
            <li key={grading}>
              <div
                className={`grid sm:grid-cols-3 grid-cols-1 items-center self-center md:justify-between md:mx-0 mx-3 min-w-0 content-start sm:border-t-0 ${
                  i > 0 && 'border-t-2 pt-2'
                }`}
              >
                {grading.split('<>').map((text, i) =>
                  i === 0 ? (
                    <div key={text} className="my-auto w-30 sm:mx-0 mx-auto">
                      <Tooltip content={getGradingTransliteration(text)} isDisabled={!getGradingTransliteration(text)}>
                        <Badge
                          disableOutline
                          className="text-xs mx-auto"
                          color={getGradingColor(text)}
                          variant={'flat'}
                        >
                          {text}
                        </Badge>
                      </Tooltip>
                    </div>
                  ) : (
                    <div
                      key={text}
                      className={`${
                        i == 1 ? 'text-center' : 'sm:text-right text-center font-semibold'
                      } my-auto h-full md:text-base text-sm`}
                    >
                      {text}
                    </div>
                  )
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Accordion>
  );
}

function getGradingColor(grading: string, dark = false) {
  const gradingLookup = (gradings as any)[grading.trim()];
  const gradingColor = gradingLookup?.color;

  // console.log(grading, gradingLookup?.color);
  // if (gradingColor === 'red') {
  //   return dark ? 'bg-red-500' : 'bg-red-400';
  // } else if (gradingColor === 'yellow') {
  //   return dark ? 'bg-yellow-500' : 'bg-yellow-400';
  // } else if (gradingColor === 'green') {
  //   return dark ? 'bg-green-500' : 'bg-green-400';
  // } else {
  //   return dark ? 'bg-gray-500' : 'bg-gray-400';
  // }

  if (gradingColor === 'red') {
    return 'error';
  } else if (gradingColor === 'yellow') {
    return 'warning';
  } else if (gradingColor === 'green') {
    return 'success';
  } else {
    return 'default';
  }
}

function getGradingTransliteration(grading: string) {
  const gradingLookup = (gradings as any)[grading.trim()];
  const gradingTransliteration = gradingLookup?.transliteration;

  return gradingTransliteration;
}
